import { render, staticRenderFns } from "./ZhanhuiLjdbBlock.vue?vue&type=template&id=05cb0315&scoped=true"
import script from "./ZhanhuiLjdbBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiLjdbBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiLjdbBlock.vue?vue&type=style&index=0&id=05cb0315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb0315",
  null
  
)

export default component.exports